import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { TemplateEditViews } from '../common/types';

export interface QueryParamContextState {
  campaignId: number;
  experimentFlow: boolean;
  isJourneyAssociated: boolean;
  locale: string;
  setCampaignId: (value: number) => void;
  setLocale: (value: string) => void;
  setTemplateId: (value: number) => void;
  setView: (value: TemplateEditViews | string) => void;
  templateId: number;
  view: TemplateEditViews | string;
  workflowNodeFlow: boolean;
}

export const queryParamContextDefaults = {
  campaignId: 0,
  experimentFlow: false,
  isJourneyAssociated: false,
  locale: '',
  setCampaignId: noop,
  setLocale: noop,
  setTemplateId: noop,
  setView: noop,
  templateId: 0,
  view: TemplateEditViews.settings,
  workflowNodeFlow: false,
};

export const QueryParamContext = createContext<QueryParamContextState>(queryParamContextDefaults);

export const useQueryParamContext = () => useContext(QueryParamContext);
